import React, {useState} from 'react';
import styled from 'styled-components';
import {labels} from '../../util/uiconstants';
import ModalControl from '@ey/modal-control';

const EngagementProfileUpdateModal = (props) => {
	const {show, editConfirmation} = props;

	const [showState, setShowState] = useState(show);

	const handleConfirm = () => {
		editConfirmation();
	};

	const handleCancel = () => {
		setShowState(false);
	};

	return (
		<ModalControl
			title={labels.titleUpdateProfile}
			modalsize="small"
			onOkClick={handleConfirm}
			confirmBtnTitle={labels.continue}
			closeTitle={labels.close}
			closeBtnTitle={labels.cancel}
			onHide={handleCancel}
			show={showState}
			backdrop="static"
			focusTrapActive={false}
		>
			<UpdateProfileEngagementStyle>
				<section id="message">
					<p className="msg1 update-modal-confimation">
						{labels.msgUpdateProfileLn1}
					</p>
				</section>
			</UpdateProfileEngagementStyle>
		</ModalControl>
	);
};
export default EngagementProfileUpdateModal;

const UpdateProfileEngagementStyle = styled.section`
	padding: var(--px-25) var(--px-24);
	.msg1 {
		font-size: var(--px-14);
		font-weight: normal;
		color: var(--neutrals-900);
		margin-bottom: 0;
	}

	.msg2 {
		font-size: var(--px-14);
		font-weight: normal;
		color: #747480;
		margin-bottom: var(--px-10);
	}
	.msg3 {
		font-size: var(--px-16);
		font-weight: bold;
		color: #2e2e38;
		margin-bottom: 0;
	}
`;
